module.exports = __webpack_public_path__ + "img/scan-orange.03bd91b3.svg";